<template>
     <div class="main">
        <div class="mainwrap">
            <van-overlay :show="show" @click="overlaybtn" />
            <div class="download" >
                <img src="../../assets/img/download_ios.png" alt="" v-if="iosdownload==true">
                <img src="../../assets/img/download_android.png" alt="" v-if="andownload==true">
            </div>
            <!-- 下载按钮 -->
            <div class="buttom" @click="downloadurlshare">
                <img src="../../assets/img/buttom.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import { Overlay ,Toast} from 'vant';
import Vue from 'vue';
import { downloadurlshareModule } from "../../request/myFreecharge";
Vue.use(Overlay );
export default {
    data(){
        return{
            show:false,
            iosdownload:false,
            andownload:false,
            androidUrl:'',
            iosUrl:''
        }
    },
    created:async function(){
        this.openapp()
    },
    methods:{
        openapp() {
            var ua = navigator.userAgent.toLowerCase();
            var browser = {
                versions: function() {
                    var u = navigator.userAgent
                    // var app = navigator.appVersion;
                    return { //移动终端浏览器版本信息
                        trident: u.indexOf('Trident') > -1, //IE内核
                        presto: u.indexOf('Presto') > -1, //opera内核
                        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                        iOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                        Android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
                        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                        iPad: u.indexOf('iPad') > -1, //是否iPad
                        webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
                    };
                }(),
                language: (navigator.browserLanguage || navigator.language).toLowerCase()
            };
       
            var u = navigator.userAgent
            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            if (isAndroid) {
                 if(browser.versions.mobile) { //判断是否是移动设备打开。browser代码在下面
                    if(browser.versions.Android) {
                        this.show=false
                        this.andownload=false
                    }
                    if(ua.match(/MicroMessenger/i) == "micromessenger") {
                        //在微信中打开
                        this.show=true
                        this.andownload=true
                    }
                    if(ua.match(/WeiBo/i) == "weibo") {
                        //在新浪微博客户端打开
                        this.show=true
                        this.andownload=true
                    }
                    if(ua.match(/QQ/i) == "qq") {
                        //在QQ空间打开
                         this.show=true
                        this.andownload=true
                    }
                } 
                // this.show=false
                //  this.andownload=false    
            }
            if (isIOS) {
                // var ua = navigator.userAgent.toLowerCase();
                if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
                    ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
                    ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1)
                {
                    this.show=false
                    this.iosdownload=false
                }else {
                    this.show=true
                    this.iosdownload=true
                }
            }
        },
        overlaybtn(){
            this.iosdownload=false
            this.andownload=false,
            this.show=false
        },
         async downloadurlshare(){
             await downloadurlshareModule.downloadurlshare(this.$route.query.marktype).then((response) => {
                console.log(response)
               switch(response.data.code){
                    case 100:
                         {
                            var u = navigator.userAgent
                            var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
                            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                            if (isAndroid) {
                                this.androidUrl =response.data.result.androidUrl 
                                window.location.href=response.data.result.androidUrl
                            // window.location.href = 'http://imtt.dd.qq.com/16891/26747DD8B125A8479AD0C9D22CA47BC9.apk?fsname=com.snda.wifilocating_4.2.91_3211.apk&csr=1bbd';
                            }
                            if (isIOS) {
                              console.log(1221,response.data.result.iosUrl)
                              this.iosUrl= response.data.result.iosUrl
                               var ua = navigator.userAgent.toLowerCase();
                                //判断是不是在iPhone的Safair浏览器打开的本页面
                                if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
                                    ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
                                    ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1)
                                {
                                    window.location.href=response.data.result.iosUrl
                                }else {
                                    this.show=true
                                    this.iosdownload=true
                                }
                            
                            //   window.location.href = 'http://imtt.dd.qq.com/16891/26747DD8B125A8479AD0C9D22CA47BC9.apk?fsname=com.snda.wifilocating_4.2.91_3211.apk&csr=1bbd';
                            }   
                            console.log(this.iosUrl,this.androidUrl)              
                         }
                        break;
                    case 101:
                        break;
                    case 102:
                        Toast.clear();
                        break;
                    case 100001:
                        // Toast.clear();
                        // Toast({
                        //     message: '网络连接异常',
                        //     position: 'center',
                        // });
                        break;
                }
            }).catch(()=>{})
        },
    }
}
</script>
<style scoped>
.main{
    width: 100%;
    min-height: 100%;
    background-image: url('../../assets/img/bg.png');
    background-size: 100%;
    background-repeat: no-repeat;
}
.download{
    width: 70%;
    position: absolute;
    top: 0.5%;
    right: 0;
    z-index: 2000;
}
.download img{
    width:100%;
    object-fit: cover;
}
.buttom{
    width: 52%;
    height: 7.6%;
    position: absolute;
    top: 75%;
    left: 24%;
}
.buttom img{
    width:100%;
    object-fit: cover;
}

</style>